const OpenLock = () => {
  return (
    <svg width="16" height="16" role="img" aria-label="Open Lock" viewBox="0 0 16 16" fill="none">
      <path stroke="#576579" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M5.111 7.222v-3.11a3.111 3.111 0 0 1 5.311-2.2m-2.2 8.421v1.556M3.556 15h9.333a1.556 1.556 0 0 0 1.555-1.556V8.778a1.555 1.555 0 0 0-1.555-1.556H3.556A1.556 1.556 0 0 0 2 8.778v4.666A1.556 1.556 0 0 0 3.556 15Z"/>
    </svg>
  );
};

export default OpenLock;
